import React from "react";
import Navbar from "../components/Navbar";
import StudioLayout from "../components/studio/StudioLayout";
import SeoHead from "../components/seo/SeoHead";

const StudioPage = () => {
  return (
    <div>
      <SeoHead
        title="Studio | Hookora"
        description="Create hooks, titles, captions, hashtags, descriptions, scripts, thumbnail text, and humanized copy inside Hookora Studio."
        path="/studio"
      />
      <Navbar />
      <StudioLayout />
    </div>
  );
};

export default StudioPage;